var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFactoryManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.68 13.587h14.945c.408 0 .68.272.68.68 0 .407-.272.679-.68.679H.679c-.407 0-.679-.272-.679-.68 0-.407.272-.679.68-.679zm2.241-1.97c-.068.407-.407.68-.883.611-.408-.068-.747-.407-.68-.747l1.36-9.783C2.92.68 3.871 0 5.027 0H7.88c1.155 0 2.106.68 2.31 1.698l1.359 9.715c.068.34-.272.68-.68.747-.407.068-.815-.203-.883-.611L8.628 1.834c-.068-.272-.34-.475-.748-.475H5.027c-.407 0-.68.204-.747.543L2.92 11.617zm8.152-8.22c0-.408.272-.68.68-.68 1.019 0 1.834.68 2.038 1.699l1.155 6.997c.068.34-.204.747-.544.747-.34.068-.747-.203-.747-.543L12.5 4.62c-.136-.34-.408-.544-.747-.544-.408 0-.68-.272-.68-.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.114 4.076h.68c.407 0 .679.272.679.68 0 .407-.272.679-.68.679h-.679c-.407 0-.68-.272-.68-.68 0-.407.273-.679.68-.679zm-.34 2.717h1.36c.407 0 .678.272.678.68 0 .407-.271.68-.679.68H5.774c-.407 0-.679-.273-.679-.68 0-.408.272-.68.68-.68zm-.34 2.718h2.039c.407 0 .68.272.68.68 0 .407-.273.679-.68.679H5.435c-.408 0-.68-.272-.68-.68 0-.407.272-.68.68-.68z"
  }))));
}

export default SvgFactoryManage;